import React from "react";
import { useNavigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { Box, Button, Container, Grid, Typography } from "@mui/material";

const LogoutCallback = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const navigation = useNavigate();

  if (!authState) {
    return <div>Loading ...</div>;
  }

  const handleLogout = async () => oktaAuth.signOut();

  const handleLogin = async () => navigation("/training");

  return (
    <Grid>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <Container maxWidth="sm">
          <Typography variant="h6" align="center" gutterBottom>
            Your session has timed out
          </Typography>
          <Typography variant="body1" align="center">
            Please log in again to continue using the Training app
          </Typography>

          <Box display="flex" justifyContent="center" mt={2}>
            {authState.isAuthenticated ? (
              <Button
                color="primary"
                variant="contained"
                id="logout-button"
                type="button"
                onClick={handleLogout}
              >
                Logout
              </Button>
            ) : (
              <Button
                color="primary"
                variant="contained"
                id="login-button"
                type="button"
                onClick={handleLogin}
              >
                Login
              </Button>
            )}
          </Box>
        </Container>
      </Box>
    </Grid>
  );
};

export default LogoutCallback;
